import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OccEndpointsService, TranslationService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { tap, take } from 'rxjs/operators';
import { CustomStockProtectionDetailsComponent } from './components/custom-stock-protection-details/custom-stock-protection-details.component';
import { CustomStockProtectionInstructionsComponent } from './components/custom-stock-protection-instructions/custom-stock-protection-instructions.component';
import { CustomFileUploadResponse } from './custom-stock-potection.models';

@Injectable({
    providedIn: 'root',
  })
export class CustomStockProtectionService {

    importSuccess: string ="importSuccess";
    importError: string ="importError";

    constructor(
        private modalService: NgbModal,
        private httpClient: HttpClient,
        private endpoints: OccEndpointsService,
        private messageService: GlobalMessageService){}

    openInstructions(){
        this.modalService.open(CustomStockProtectionInstructionsComponent, { centered: true, size: 'lg' });
    }

    openDetails(processNumber: string, productCode: string, inactive: boolean){
        const modalRef = this.modalService.open(CustomStockProtectionDetailsComponent, { centered: true, scrollable: true, size: 'lg' });
        modalRef.componentInstance.processNumber = processNumber;
        modalRef.componentInstance.productCode = productCode;
        modalRef.componentInstance.inactive = inactive;
    }

    importFile(file: File){
      var formData: FormData = new FormData();
      formData.append('file',file,file.name);
      const url = this.endpoints.buildUrl('customSerialNumbersUpload');
        this.httpClient
        .post(url,formData)
          .pipe(
            tap(
              (data) => {
                this.showMessage(data);  
              }
            )
          )
          .subscribe((_res) => {});
    }

    showMessage(data: Object): void{
      let response: CustomFileUploadResponse = JSON.parse(data.toString());
      if(response.status == this.importSuccess){
        this.messageService.add(
          response.hint,
          GlobalMessageType.MSG_TYPE_INFO
        );
      }
      else if(response.status == this.importError){
        this.messageService.add(
          response.hint,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    }
}
